<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import {showAlert} from 'src/components/#common/alert/store'
    import {Link} from 'svelte-routing'
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import arrow from './arrow.svg'
    import lisIcon from 'src/components/#assets/realis-icon.svg'
    import bybitLogo from 'src/components/cabinet/withdrawal/bybit.svg'
    import nearLogo from 'src/components/cabinet/withdrawal/near.svg'
    import nearIcon from 'src/components/cabinet/withdrawal/near-icon.svg'
    import {getSettingOption} from 'src/components/cabinet/#services/settingsOption'
    import {delay} from 'src/global/delay'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import Time from 'svelte-time'
    import {navigate} from 'src/global/navigate'
    import EmailSent from 'src/components/cabinet/withdrawal/components/Countdown.svelte'
    import IconifyIcon from '@iconify/svelte'
    import cancelIcon from '@iconify/icons-fa-solid/times'
    import resendIcon from '@iconify/icons-fa-solid/redo-alt'
    import {
        withdraw,
        withdrawTransactions,
        confirmWithdraw,
        cancelWithdraw,
        resendWithdrawConfirmation
    } from 'src/components/cabinet/#services/withdraw'
    import QRcodeScanner from 'src/components/cabinet/withdrawal/components/QRcodeScanner.svelte'
    import Countdown from 'src/components/cabinet/withdrawal/components/Countdown.svelte'

    let selectedCoinName = 'DRAG'
    let selectedNetwork = 'BSC'
    const urlParams = new URLSearchParams(window.location.search)
    let hash = urlParams.has('hash') ? urlParams.get('hash') : ''
    let token = urlParams.has('t') ? urlParams.get('t') : ''
    if (hash) {
        confirmWithdrawHandler(hash)
    }

    let withdrawalMin
    let withdrawFee

    async function withdrawInit(token = undefined) {
        if (token && token === 'USDT') {
            selectedCoinName = token
            selectedNetwork = 'BSC'
        }
        // if (token && ['NEAR'].includes(token)) {
        //     selectedNetwork = 'Near'
        // }
        // if (token && ['USDT'].includes(token)) {
        //     selectedNetwork = 'BSC'
        // }
        // if (token && ['DRAG', 'MATIC'].includes(token)) {
        //     selectedNetwork = 'Polygon'
        // }
        withdrawFee = await getSettingOption.request({ data: { clientKey: "withdrawalFee."+selectedCoinName } })
        withdrawalMin = await getSettingOption.request({ data: { clientKey: "withdrawalMin."+selectedCoinName } })
    }

    withdrawInit(token)

    let currentPage = 0
    let perPage = 10

    function withdrawTransactionsList() {
        withdrawTransactions.reset()
        getWithdrawTransactions = undefined
        $: withdrawTransactions.send({ data: { page: currentPage + 1, perPage }})
    }

    $:currentPage,perPage,withdrawTransactionsList()

    function maxAmount() {
        if ($myBalance.value?.data) {
            amount = roundNumber(+$myBalance?.value.data[selectedCoinName])
        }
    }

    let address
    $: isValidNearAddress = /^[a-z0-9\-\_]{2,56}(\.near)$|^[a-z0-9]{64}$/.test(address)
    $: isValidPolygonAddress = /^(0x)[a-fA-F0-9]{40}$/.test(address)
    $: address
    let amount
    $: userWillGet = amount > withdrawFee?.value && withdrawFee?.value ? Math.floor((amount - withdrawFee.value) * 10000) / 10000 : 0
    let coinDropdownOpen = false
    let networkDropdownOpen = false
    let selectedWithdrawalItemId
    let resendWithdrawalConfirmation = false
    let confirmWithdrawalModalOpen = false
    let selectCoinDisabled = false
    let withdrawSending = false
    let confirmSending = false
    let cancelSending = false
    let addressError = false
    let amountError = false
    let confirmationCode

    function changeCoin(name) {
        selectedCoinName = name
        coinDropdownOpen = false
        withdrawalMin = undefined
        withdrawFee = undefined
        withdrawInit(name)
    }

    function changeNetwork(network) {
        selectedNetwork = network
        networkDropdownOpen = false
    }

    async function confirmWithdrawHandler(hash) {
        try {
            await confirmWithdraw.request({data: {hash}})

            showAlert.set({
                status: 'success',
                text: 'The withdrawal request has been successfully confirmed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            hash = ''
            resendWithdrawalConfirmation = false
            navigate("/withdrawal")
            await delay(500)
            withdrawTransactionsList()
        }
    }

    async function confirmWithdrawByCode() {
        try {
            confirmSending = true

            await confirmWithdraw.request({data: { code: confirmationCode }})

            showAlert.set({
                status: 'success',
                text: 'The withdrawal request has been successfully confirmed'
            })

            confirmationCode = ''
            resendWithdrawalConfirmation = false
            confirmWithdrawalModalOpen = false
            await delay(500)
            withdrawTransactionsList()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            confirmSending = false
        }
    }

    async function withdrawHandler() {
        addressError = !address
        amountError = !amount

        if (addressError || amountError) {
            return false
        }

        try {
            withdrawSending = true
            await withdraw.request({ data: {
                network: selectedNetwork.toLowerCase(),
                currency: selectedCoinName,
                receiverAddress: address,
                amount: amount.toString()
            }})

            address = ''
            amount = ''
        } catch (err) {
            if (err.message) {
                if (err.message == 'Action has gone on solution') {
                    showAlert.set({
                        status: 'success',
                        text: 'We have sent an email to confirm your withdrawal'
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                }
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            resendWithdrawalConfirmation = false
            withdrawSending = false
            await delay(500)
            myBalance.reset()
            myBalance.send()
            withdrawTransactionsList()
        }
    }

    async function cancelWithdrawHandler(id) {
        try {
            cancelSending = true
            await cancelWithdraw.request({ data: { id } })

            showAlert.set({
                status: 'success',
                text: 'The withdrawal was successfully canceled'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            resendWithdrawalConfirmation = false
            cancelSending = false
            myBalance.reset()
            myBalance.send()
            await delay(500)
            withdrawTransactionsList()
        }
    }

    async function resentConfirmation(id) {
        try {
            await resendWithdrawConfirmation.send({ data: { id }})

            resendWithdrawalConfirmation = true

            if (!confirmWithdrawalModalOpen) {
                showAlert.set({
                    status: 'success',
                    text: 'We have re-sent the email'
                })
            }
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    let getWithdrawTransactions
    $: if (!getWithdrawTransactions && $withdrawTransactions.hasValue) {
        getWithdrawTransactions = $withdrawTransactions.value && JSON.parse(JSON.stringify($withdrawTransactions.value))
        getWithdrawTransactions?.data.forEach(function (item){
            if (item.status === 'onConfirmation' && !confirmWithdrawalModalOpen && !hash) {
                confirmWithdrawalModalOpen = true
                selectedWithdrawalItemId = item.id
            }
        })
    }

    function getWithdrawalLink(network, currency) {
        if (network === 'bsc') {
            return 'https://bscscan.com/address/'
        } else if (network === 'near') {
            return 'https://nearblocks.io/address/'
        } else if (network === 'polygon') {
            return 'https://polygonscan.com/address/'
        }
    }
</script>

<svelte:head>
    <title>Withdrawal</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">
                <Link to="account" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>Withdrawal
            </div>
            <Alert />
            <div class="withdrawal-form">
                <div class="form-group">
                    <label>Coin</label>
                    <div class="dropdown" use:clickOutside={() => {coinDropdownOpen = false}}
                         class:active={coinDropdownOpen}
                         class:disabled={selectCoinDisabled}>
                        <div class="dropdown-selected">
                            <div class="need-select notranslate" on:click={() => { if (!selectCoinDisabled) coinDropdownOpen = !coinDropdownOpen }}>
                                <img src="/images/tokens/{selectedCoinName.toUpperCase()}.svg" class="coin-icon" alt="">
                                {selectedCoinName.toUpperCase()}
                                <img src="{arrow}" class="arrow" alt="">
                            </div>
                        </div>
                        <div class="dropdown-list">
                            <div class="item notranslate" on:click={() => changeCoin('DRAG')}>
                                <img src="/images/tokens/WLIS.svg" class="coin-icon" alt="">DRAG
                            </div>
<!--                            <div class="item notranslate" on:click={() => changeCoin('NEAR')}>-->
<!--                                <img src="/images/tokens/NEAR.svg" class="coin-icon" alt="">NEAR-->
<!--                            </div>-->
                            <div class="item notranslate" on:click={() => changeCoin('USDT')}>
                                <img src="/images/tokens/USDT.svg" class="coin-icon" alt="">USDT
                            </div>
<!--                            <div class="item notranslate" on:click={() => changeCoin('MATIC')}>-->
<!--                                <img src="/images/tokens/MATIC.svg" class="coin-icon" alt="">MATIC-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
                {#if ['DRAG', 'USDT'].includes(selectedCoinName)}
                    <div class="form-group">
                        <label>Network</label>
                        <div class="dropdown" use:clickOutside={() => {networkDropdownOpen = false}}
                             class:active={networkDropdownOpen}>
                            <div class="dropdown-selected">
                                <div class="need-select notranslate" on:click={() => { networkDropdownOpen = !networkDropdownOpen }}>
                                    BNB Chain <img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="dropdown-list">
                                <div class="item notranslate" on:click={() => changeNetwork('BSC')}>
                                    BNB Chain
                                </div>
<!--                                <div class="item notranslate" on:click={() => changeNetwork('Polygon')}>-->
<!--                                    Polygon-->
<!--                                </div>-->
<!--                                <div class="item notranslate" on:click={() => changeNetwork('Near')}>-->
<!--                                    Near-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>
                {/if}
                <div class="form-group">
                    <div class="d-flex justify-content-between align-items-end">
                        <label>Address</label>
                        {#if selectedNetwork === 'Near'}
                            <a href="https://realis.network/blog/where-to-find-referral-link-in-realis.network-and-create-an-account-on-Bybit-crypto-exchange" target="_blank" class="how-create-wallet">
                                How to create?
                            </a>
                        {/if}
                    </div>
                    <div class="wallet-address">
                        <input type="text" class="form-control address-field" placeholder="Enter address" bind:value={address}>
                        <QRcodeScanner bind:address={address}/>
                    </div>
                    <div class="invalid-feedback" class:d-block={addressError}>Enter wallet address</div>
                    <div class="invalid-feedback" class:d-block={address && ((selectedNetwork === 'Near' && !isValidNearAddress) || (selectedNetwork === 'Polygon' && !isValidPolygonAddress) || (selectedNetwork === 'BSC' && !isValidPolygonAddress))}>
                        Wallet address invalid
                    </div>
                    {#if selectedNetwork === 'Near'}
                        <div class="invalid-feedback orange-color d-block">If it's MyNearWallet you must have 0.004+ NEAR to see DRAG</div>
                    {/if}
                </div>
                <div class="form-group mb-2">
                    <div class="d-flex justify-content-between align-items-end">
                        <label>Amount</label>
                        <div class="withdraw-balance">Balance:
                            {#if !$myBalance.hasValue && $myBalance.loading}
                                Loading...
                            {:else if $myBalance.hasValue}
                                <span class="notranslate">
                                    {roundNumber(+$myBalance.value?.data[selectedCoinName.toUpperCase()])}
                                    {selectedCoinName === 'DRAG' ? 'DRAG' : selectedCoinName.toUpperCase()}
                                </span>
                            {:else if $myBalance.error}
                                Error
                            {/if}
                        </div>
                    </div>
                    <div class="input-group">
                        <input type="number" class="form-control amount-field" bind:value={amount} placeholder="Enter amount">
                        <button class="btn btn-max-amount" on:click={maxAmount}>max</button>
                    </div>
                    <div class="invalid-feedback" class:d-block={amountError}>Enter amount</div>
                </div>
                <div class="form-group">
                    {#if !withdrawalMin || withdrawalMin?.value > 0}
                        <div class="withdrawal-info">
                            <div>Min withdrawal amount</div>
                            {#if !withdrawalMin}
                                <div>Loading...</div>
                            {:else}
                                <div class="notranslate">
                                    {withdrawalMin?.value}
                                    {selectedCoinName === 'WLIS' ? 'DRAG' : selectedCoinName}
                                </div>
                            {/if}
                        </div>
                    {/if}
                    {#if !withdrawFee || withdrawFee?.value > 0}
                        <div class="withdrawal-info">
                            <div>Withdraw fee</div>
                            {#if !withdrawFee}
                                <div>Loading...</div>
                            {:else}
                                <div class="notranslate">
                                    {withdrawFee?.value}
                                    {selectedCoinName === 'WLIS' ? 'DRAG' : selectedCoinName}
                                </div>
                            {/if}
                        </div>
                    {/if}
                    <div class="withdrawal-info">
                        <div>You will get:</div>
                        <div class="notranslate">{userWillGet} {selectedCoinName === 'WLIS' ? 'DRAG' : selectedCoinName}</div>
                    </div>
                    {#if selectedNetwork === 'Near'}
                        <div class="withdrawal-info">
                            <div>Recommended:</div>
                            <div class="recommended-logo d-flex">
                                <a href="https://partner.bybit.com/b/realis" target="_blank" class="mr-25">
                                    <img src="{bybitLogo}" alt="bybit">
                                </a>
                                <a href="https://www.mynearwallet.com" target="_blank">
                                    <img src="{nearLogo}" alt="near">
                                </a>
                            </div>
                        </div>
                    {/if}
                </div>
                <button class="btn btn-primary w-100" on:click={withdrawHandler} class:loading={withdrawSending}
                    disabled={withdrawSending || userWillGet === 0 || amount > +$myBalance?.value?.data[selectedCoinName] ||
                    amount < withdrawalMin?.value || (selectedNetwork === 'Near' && !isValidNearAddress) ||
                    (selectedNetwork === 'Polygon' && !isValidPolygonAddress)}>
                    <span>Withdraw</span>
                </button>
            </div>

            {#if !getWithdrawTransactions && $withdrawTransactions.loading}
                <div class="my-transactions-table text-center">Loading...</div>
            {:else if !getWithdrawTransactions && $withdrawTransactions.error }
                <div class="my-transactions-table text-center">Something went wrong. Try refreshing the page.</div>
            {:else if getWithdrawTransactions && $withdrawTransactions.hasValue && getWithdrawTransactions.totalCount > 0}
                <div class="my-transactions-table">
                    <div class="transactions-table-header">
                        <div>Status</div>
                        <div>Amount</div>
                        <div>Address</div>
                        <div>Date</div>
                    </div>
                    <div class="transactions-table-body">
                        {#each getWithdrawTransactions?.data as { id, recipientAddress, amount, fee, network, currency, status, transactionHash, createdAt }}
                            <div class="transactions-table-row">
                                <div>
                                    {#if status !== 'onConfirmation'}
                                        <span class="label d-md-none">Status:</span>
                                    {/if}
                                    {#if status === 'onApproving' || status === 'approved' || status === 'confirmed'}
                                        <span class="status-pending">Pending</span>
                                        <Countdown date={createdAt} status="pending"/>
                                    {:else if status === 'onConfirmation'}
                                        <span class="status-sending">Email sent</span>
                                        {#if !resendWithdrawalConfirmation}
                                            <div class="tooltip-wrapper">
                                                <button on:click={() => resentConfirmation(id)} class="resend-btn">
                                                    <IconifyIcon icon={resendIcon}/>
                                                </button>
                                                <div class="tooltip">Resend</div>
                                            </div>
                                        {/if}
                                        <Countdown date={createdAt} status="sending"/>
                                    {:else if status === 'notApproved' || status === 'notConfirmed' || status === 'error'}
                                        <span class="status-returned">Returned</span>
                                    {:else if status === 'success'}
                                        <span class="status-success">Success</span>
                                    {:else}
                                        {status}
                                    {/if}
                                </div>
                                <div class="notranslate">{roundNumber(+amount - +fee)} {currency === 'DRAG' ? 'DRAG' : currency}</div>
                                <div>
                                    {#if recipientAddress}
                                        <a href="{getWithdrawalLink(network, currency)}{recipientAddress}" class="address notranslate" target="_blank">
                                            {#if recipientAddress.length >= 20}
                                                {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                                            {:else}
                                                {recipientAddress}
                                            {/if}
                                        </a>
                                    {:else}
                                        <span class="address notranslate">
                                            {#if recipientAddress.length >= 20}
                                                {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                                            {:else}
                                                {recipientAddress}
                                            {/if}
                                        </span>
                                    {/if}
                                </div>
                                <div>
                                    <span class="label d-md-none">Date:</span>
                                    <Time live relative timestamp={createdAt}/>
                                    {#if status === 'onConfirmation'}
                                        <button class="cancel-btn" on:click={cancelWithdrawHandler(id)} disabled={cancelSending}>
                                            <IconifyIcon icon="{cancelIcon}"/>
                                        </button>
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    </div>
                    <Pagination bind:currentPage={currentPage} totalCount={getWithdrawTransactions.totalCount} {perPage}/>
                </div>
                <Modal bind:visible={confirmWithdrawalModalOpen}>
                    <svelte:fragment slot="content">
                        <div class="modal-custom__title">Confirm your withdrawal</div>
                        <div class="modal-custom__text text-center">
                            <Alert />
                            We have sent an email to confirm your withdrawal. Enter the code or click on the button in the withdrawal confirmation email.<br>
                            <input type="text" class="form-control confirmation-code" placeholder="Enter code" bind:value={confirmationCode}>
                            {#if selectedWithdrawalItemId && !resendWithdrawalConfirmation}
                                <div class="resend-confirmation">Didn't receive an Email?
                                    <span on:click={() => resentConfirmation(selectedWithdrawalItemId)}>Resend</span>
                                </div>
                            {:else}
                                <div class="resend-confirmation">We have re-sent the email.</div>
                            {/if}
                        </div>
                        <div class="modal-custom__footer">
                            <button class="btn btn-cancel" on:click={() => { confirmWithdrawalModalOpen = false }}>Cancel</button>
                            <button class="btn btn-primary" on:click={confirmWithdrawByCode} class:loading={confirmSending} disabled={confirmSending || !confirmationCode}><span>Confirm</span></button>
                        </div>
                    </svelte:fragment>
                </Modal>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .wallet-address {
        position: relative;
    }

    .tooltip-wrapper {
        margin-top: -17px;
        margin-left: 5px;
    }

    .tooltip-wrapper .tooltip {
        opacity: 0;
        visibility: hidden;
        background: #61758a;
        font-size: 14px;
        color: white;
        line-height: 1.2;
        padding: 5px 10px;
        transform: translateX(-50%);
        margin-left: 10px;
        margin-top: -64px;
        text-align: center;
        border-radius: 3px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
        transition: opacity .2s, margin .2s;
        z-index: 2;
    }

    .tooltip-wrapper .tooltip:after {
        content: "";
        position: absolute;
        border: 8px solid transparent;
        border-top: 8px solid #61758a;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
    }

    .tooltip-wrapper:hover .tooltip {
        display: block;
        opacity: 1;
        visibility: visible;
        margin-top: -58px;
    }

    .orange-color {
        color: #ff5d1c;
        margin-top: 6px;
    }
    .withdrawal-form {
        max-width: 500px;
        margin: 40px auto 20px;
    }

    .withdrawal-form .form-control {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
    }

    .cancel-btn {
        background: none;
        border: 0;
        padding: 0;
        font-size: 22px;
        color: #f44336;
        position: absolute;
        right: 7px;
        width: 30px;
        opacity: .8;
        transition: .25s;
    }

    .cancel-btn:hover {
        opacity: 1;
    }

    .confirmation-code {
        max-width: 250px;
        text-align: center;
        box-shadow: inset 0 0 0 2px #c2c2c3;
        margin: 20px auto 22px;
    }

    .confirmation-code:focus {
        box-shadow: inset 0 0 0 2px #FF5D1C !important;
    }

    .alert-danger {
        font-size: 15px;
        padding: 14px 20px;
        background: #ce4036;
        border-color: #ce4036;
        color: white;
    }

    .status-success {
        color: #27AE60;
    }

    .status-pending {
        color: #ff9800;
        margin-top: -15px;
        font-size: 17px;
    }

    .status-sending {
        color: #ff9800;
        margin-top: -15px;
        font-size: 17px;
    }

    .status-returned {
        color: #da4848;
    }

    .withdraw-balance {
        font-size: 13px;
        color: #b9b8b8;
        margin-block: 5px;
    }

    .address {
        color: white;
        text-decoration: none;
        transition: .25s;
    }

    a.address:hover {
        text-decoration: underline;
    }

    :global(.how-create-wallet) {
        font-size: 13px;
        color: #b9b8b8;
        margin-block: 5px;
        text-decoration: none;
    }

    :global(.how-create-wallet:hover) {
        color: #e1e1e1;
        text-decoration: underline;
    }

    .instruction-free-lis :global(a) {
        color: white;
    }

    .btn-max-amount {
        background: #61758A;
        border-color: #cad5e0;
        color: white;
    }

    .btn-max-amount:hover {
        background: #ff5d1c;
    }

    .form-group label {
        font-size: 15px;
        margin-bottom: 5px;
    }

    .form-control:focus {
        box-shadow: none;
    }

    .coin-icon {
        height: 30px;
        width: 30px;
        margin: -6px 8px -6px 0;
        vertical-align: top;
        background: white;
        border-radius: 50%;
        padding: 3px;
        object-fit: contain;
        object-position: center;
    }

    .form-group {
        margin-bottom: 18px;
    }

    .withdrawal-info {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        padding: 8px 0;
        color: lightgrey;
    }

    .dropdown {
        background: #343168;
        border-radius: 6px;
        position: relative;
        z-index: 4;
    }

    .dropdown.active {
        z-index: 5;
    }

    .dropdown.disabled {
        opacity: 0.6;
    }

    .dropdown.disabled .dropdown-selected {
        cursor: default;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 18px;
        color: white;
        font-weight: 500;
        border: 1px solid #CAD5E0;
        border-radius: 6px;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 12px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 16px 12px;
        height: 50px;
        margin: -10px;
    }

    .dropdown-list {
        display: none;
        padding: 10px 20px;
        position: absolute;
        background: #343168;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #CAD5E0;
        margin-top: 10px;
        z-index: 2;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .item {
        font-size: 16px;
        color: white;
        padding: 12px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .item:not(:last-child) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .dropdown-list .item:hover {
        color: #cbcaca;
    }

    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .transactions-table-header {
        display: flex;
        width: 100%;
        margin-bottom: 15px;
    }

    .transactions-table-header > div {
        width: 20%;
        padding: 15px 50px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 18px;
        line-height: 20px;
        font-weight: 500;
    }

    .transactions-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .transactions-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .transactions-table-row {
        border: 1px solid #CAD5E0;
        border-radius: 8px;
        display: flex;
        width: 100%;
        margin-bottom: 10px;
    }

    .transactions-table-row > div {
        width: 20%;
        padding: 15px 50px;
        font-size: 20px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        white-space: nowrap;
        position: relative;
    }

    .my-transactions-table {
        margin: 60px auto 0;
        max-width: 1174px;
    }

    .transactions-table-header > div:nth-child(3),
    .transactions-table-header > div:nth-child(4),
    .transactions-table-row > div:nth-child(3),
    .transactions-table-row > div:nth-child(4) {
        width: 30%;
    }

    .mr-25 {
        margin-right: 25px;
    }

    .recommended-logo img {
        opacity: 0.8;
        transition: .2s;
    }

    .recommended-logo a:hover img {
        opacity: 1;
    }

    .resend-confirmation {
        margin: -5px 0;
        color: #bbbbbb;
        font-size: 15px;
    }

    .resend-confirmation span {
        color: #ff5d1c;
        cursor: pointer;
    }

    .resend-btn {
        padding: 0;
        border: 0;
        font-size: 12px;
        vertical-align: top;
        border-radius: 3px;
        width: 18px;
        min-width: 18px;
        height: 18px;
        line-height: 18px;
        background: #cad5e0;
        color: #272c33;
        position: relative;
        z-index: 3;
    }

    .amount-field::-webkit-outer-spin-button,
    .amount-field::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
    }

    .amount-field {
        -moz-appearance: textfield !important;
    }

    @media(max-width: 1199px) {
        .transactions-table-row > div,
        .transactions-table-header > div {
            padding: 15px 20px;
            font-size: 16px;
        }
    }

    @media(max-width: 991px) {
        .withdrawal-form .address-field {
            padding-right: 50px;
        }
    }

    @media(max-width: 767px) {
        .withdrawal-form {
            margin: 20px auto;
        }

        .alert-danger {
            font-size: 14px;
            padding: 8px 12px;
        }

        .need-select {
            padding: 13px 20px;
            height: 46px;
        }

        .dropdown-selected {
            font-size: 16px;
        }

        .transactions-table-header {
            display: none;
        }

        .transactions-table-row {
            flex-wrap: wrap;
            padding: 5px 0;
            margin-bottom: 15px;
            position: relative;
        }

        .transactions-table-row > div {
            width: 50%;
            position: relative;
            padding: 5px 15px;
        }

        .transactions-table-row > div:nth-child(2) {
            justify-content: flex-end;
            position: absolute;
            right: 0;
            top: 35px;
        }

        .transactions-table-row > div:nth-child(3),
        .transactions-table-row > div:nth-child(4) {
            width: 100%;
        }

        .label {
            padding-right: 5px;
            font-size: 16px !important;
            margin-bottom: 0 !important;
        }

        .my-transactions-table {
            margin: 40px auto 0;
        }

        .mr-25 {
            margin-right: 20px;
        }

        .status-sending,
        .status-pending {
            margin-top: 0;
            font-size: 16px;
        }

        .tooltip-wrapper {
            margin-top: 0;
        }
    }
</style>
